"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var getState_1 = require("../../../../utils/getState");
var core_1 = require("@rradar/core");
var Login = function () {
    return (React.createElement("div", { className: "login-container flex-column" },
        React.createElement("div", { className: "sign-up-container" },
            React.createElement("div", { className: "sign-up-area" },
                React.createElement("header", null,
                    React.createElement("h1", null, "Ready to get started?")),
                React.createElement("p", null, "To use the rradarrecover platform, you will need to have an active subscription. Use the button below to log in to your account."),
                React.createElement("form", { className: "sign-up-form" },
                    React.createElement(core_1.Button, { buttonType: "primary", onClick: function () {
                            window.location.href = "".concat((0, getState_1.default)().api.authentication_url);
                        } }, "Log in"))))));
};
exports.default = Login;
